module.exports = "https://static.wagwalking.com/_next/static/images/Avatar-0-9a5c2010e9d4e90514cc0cb127e69009.svg";